import React from 'react';
import { useParams } from 'react-router-dom';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import SEO from '../common/SEO';
import BlogGridTwo from '../component/blog/BlogGridTwo';
import BlogData from "../data/blog/BlogData.json";
import BreadCrumbOne from '../elements/breadcrumb/BreadCrumbOne';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import {slugify} from '../utils';
import SplashCta from '../component/cta/SplashCta';
import { Helmet } from 'react-helmet';


const allBlogData = BlogData;

const BlogCategory = () => {

    const params = useParams();
    const blogSlug = params.slug;

    const getBlogData = allBlogData.filter(blog => slugify(blog.category) === blogSlug);
    const detailsBlog = getBlogData[0];


    return (
        <>
        <Helmet>
            <meta name='robots' content='index, follow' />
            <meta name='description' content={detailsBlog['category-meta']}/>
            <meta name='keywords' content={`Zuse Technologies, Category, ${blogSlug}, Innovative IT Solutions, Cutting-edge Technology, Reliable Services, Business-driven Technology, Advanced Technology Practices`} />
            <link rel="canonical" href={`https://zuse.lk/category/${blogSlug}/`} />
        </Helmet>
        <SEO title={detailsBlog.category+ " Category"} />
        <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />
                <BreadCrumbOne 
                title={detailsBlog.category + " Category"}
                page="Product Category"
                />
                <div className="section-padding-equal">
                    <div className="container">
                        <div className="row">
                            <BlogGridTwo data={getBlogData} colSize="col-lg-4"/>
                        </div>
                    </div>
                </div>
                <SplashCta />
            <FooterOne parentClass="" />
            </main>
        </>
    )
}

export default BlogCategory;